import React from 'react';
import './AdminMenu.scss';
import avatar_img from '../../../styles/avatar_default.png';
import Config from '../../../config/config';
import { closeAdminDataTaskView } from '../adminSlice';
import { getAllDataForTasks } from '../../MainVIew/Tasks/taskSlice';

const AdminMenu = (props) => {
    const serverPath = Config.serverPath;
    const avatarName = props.authData.avatarName;
    const userId = props.authData.id;
    const {dispatch} = props;
    
    let avatar_src = avatar_img;
if (avatarName.user_image_name) {
    avatar_src = `${serverPath}/api/avatar/${userId}/${props.authData.avatarName.user_image_name}`;
}
    //const avatar_src = avatarName? `${serverPath}/api/avatar/${userId}/${props.authData.avatarName}`: avatar_img;   
    
   const  handleClick = (e) => {
        const id = e.target.value;
        props.handlerAdminView(id);
        if (id === "4") {
            console.log(id);
            dispatch(getAllDataForTasks());
       }
       dispatch(closeAdminDataTaskView());

      }  
      
        return (
            
            <div className="AdminMenu">
                <div className='menu-avatar'>
                    <img src={avatar_src} alt="Avatar" className="avatar"/>
                    <div className='container'>
                        <span className='avatar-name'>{props.authData.username}</span>
                        <br></br>
                        <span className='avatar-occupation'>{props.authData.occupation}</span>
                        <br></br>
                        {props.authData.userRole[0].role_id ===1 ? <span className='avatar-role'> Администратор </span> : null}
                    </div>

                </div>
                <hr></hr>
                <ul>
                   {/* <li><button id="test" onClick={this.handleClick} value="0">Курсы</button></li>*/}
                   <li><button className="client" onClick={props.closeAdminView} value="1">Назад</button></li>
                    <li><button className="modules" onClick={handleClick} value="1">Модули</button></li>
                    {(props.authData.userRole[0].role_id ===1) ? <li><button className="users" onClick={handleClick} value="2">Пользователи</button></li> : null}
                    {(props.authData.modulesName[4].status || (props.authData.userRole[0].role_id === 1)) ? <li><button className="lit" onClick={handleClick} value="3">Литература</button></li> : null}
                    {(props.authData.modulesName[7].status || (props.authData.userRole[0].role_id === 1)) ? <li><button className="tasks" onClick={handleClick} value="4">Задачи</button></li> : null}
                </ul>
             
            </div>
        )
    }

export default AdminMenu;